import { ExportOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { Message } from '../vitrual-assistant.type';
import { KgdAvatar } from './avatar/kgd-avatar';
import { UserAvatar } from './avatar/user-avatar';

interface ChatMessageProps {
    message: Message;
    action?: () => void;
    showAvatar: boolean;
}

const ChatMessage = ({ message: { from, text }, action, showAvatar }: ChatMessageProps) => {
    const showAssistantAvatar = showAvatar && from === 'assistant';
    const showUserAvatar = showAvatar && from === 'user';

    return (
        <li
            className={clsx('message__wrapper', `message__wrapper__${from}`, {
                show_avatar: showAvatar,
            })}
        >
            {showAssistantAvatar && <KgdAvatar />}

            <div
                className={clsx('message', `message__${from}`, {
                    message_clickable: Boolean(action),
                })}
                {...(action ? { onClick: action } : {})}
            >
                <Space align="start">
                    {action && <ExportOutlined />}
                    {text}
                </Space>
            </div>

            {showUserAvatar && <UserAvatar />}
        </li>
    );
};

export default ChatMessage;
